function hk_movements_Reducer(state = [], action) {
    switch (action.type) {
        case 'HK_MOVEMENTS/SET':
            return action.movements;
        case 'HK_MOVEMENTS/CLEAR':
            return [];
        default:
            return state;
    }
}

export default hk_movements_Reducer;
